import { render, staticRenderFns } from "./schoolSearch.vue?vue&type=template&id=ab88fbc8&scoped=true"
import script from "./schoolSearch.vue?vue&type=script&lang=ts"
export * from "./schoolSearch.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab88fbc8",
  null
  
)

export default component.exports